export function objectToFormData(obj: object) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value == "object" && "length" in value) {
      for (let i = 0; i < value.length; i++) {
        formData.append(`${key}[]`, value[i]);
      }
    } else if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }
  }
  return formData;
}
